import React from 'react';

function GeneralStatsComponent(props) {

    return(
    <React.Fragment>
        <div className="questionaire__reports__container questionaire__reports__container--status">
            <div className="questionaire__reports__container__item">
                <span className="questionaire__reports__container__item__title">Number of responses</span>
                <span className="questionaire__reports__container__item__number">{props.totalAnswers}</span>
                <span className="questionaire__reports__container__item__details">answers</span>
            </div>
            <div className="questionaire__reports__container__item">
                <span className="questionaire__reports__container__item__title">Average time to complete</span>
                <span className="questionaire__reports__container__item__number">{props.averageTimeOfComp}</span>
                <span className="questionaire__reports__container__item__details">minutes</span>
            </div>
            <div className="questionaire__reports__container__item">
                <span className="questionaire__reports__container__item__title">Abandon rate</span>
                <span className="questionaire__reports__container__item__number">{props.abandonRate}</span>
                <span
                    className="questionaire__reports__container__item__details">of the people who opened the survey</span>
            </div>
        </div>
    </React.Fragment>
    )


}
export default GeneralStatsComponent;